import { SettingsAboutAsync } from '#pages/settings-about';
import { SettingsAboutLiteAsync } from '#pages/settings-about-lite';
import { checkIsLiteStore } from '#shared/lib/storeInfo';

export const SettingsAboutPageRoute = () => (checkIsLiteStore() ? <SettingsAboutLiteAsync /> : <SettingsAboutAsync />);
